import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const NewsNoticeDetails = () => {
    const { catagory, id } = useParams();
    const [notice, setNotice] = useState(null);

    useEffect(() => {
        fetch("/data/notice.json")
            .then((res) => res.json())
            .then((data) => {
                const filteredNotice = data.find(
                    (item) => item.type === catagory && item._id === id
                );
                setNotice(filteredNotice);
            });
    }, [catagory, id]);

    if (!notice) {
        return <p className="text-center text-lg">Loading...</p>;
    }

    return (
        <div className="flex justify-center items-center min-h-screen">
            <div className="text-center max-w-3xl p-4">
                <h1 className="text-xl md:text-3xl py-4 uppercase font-bold text-primary underline">
                    {notice.type}
                </h1>
                <p>Date: {notice.date}</p>
                <h1 className="text-justify  text-xl md:text-2xl py-4">{notice.title}</h1>
                <img className="mx-auto" src={notice.image} alt="newsNotice" />
                <p className="text-justify ">{notice.text1}</p>
                <p className="text-justify ">{notice.text2}</p>

                <h1 className="text-xl md:text-2xl py-4">{notice.head1}</h1>
                <p className="text-justify">{notice.dept1}</p>
                <p className="text-justify">{notice.dept2}</p>
                <p className="text-justify">{notice.dept3}</p>
                <p className="text-justify">{notice.dept4}</p>
                <p className="text-justify">{notice.dept5}</p>

                <h1 className="text-xl md:text-2xl py-4">{notice.head2}</h1>
                <p className="text-justify">{notice.text10}</p>
                <p className="text-justify">{notice.text11}</p>
                <p className="text-justify">{notice.text12}</p>
                <p className="text-justify">{notice.text13}</p>
            </div>
        </div>
    );
};

export default NewsNoticeDetails;
